// extracted by mini-css-extract-plugin
export var backdropBlur = "_cx-0";
export var contentCard = "_cx-5";
export var frame = "_cx-2";
export var image = "_cx-4";
export var imagePane = "_cx-3";
export var modal = "_cx-1";